// Kreyòl ayisyen — landing page + auth pages. Other keys fall back to
// English automatically via i18next's fallbackLng.
const ht = {
  translation: {
    common: {
      loading: "K ap chaje…",
      error_generic: "Yon erè rive. Tanpri eseye ankò.",
      verifying: "K ap verifye…",
    },
    auth: {
      brand_tagline: "Platfòm mondyal rechaj mobil pou revandè",
      sign_in_title: "Konekte nan kont ou",
      sign_in_sub: "Antre enfòmasyon w yo pou kontinye.",
      welcome_back: "Byenvini ankò !",
      username_placeholder: "Antre non itilizatè ou",
      password_placeholder: "Antre modpas ou",
      username: "Non itilizatè",
      username_or_email: "Non itilizatè oswa imèl",
      password: "Modpas",
      remember_me: "Sonje m",
      sign_in: "Konekte",
      signing_in: "K ap konekte…",
      forgot_password: "Bliye modpas?",
      new_here: "Nouvo isit la ?",
      create_account: "Kreye yon kont",
      have_account: "Ou gen deja yon kont ?",
      email: "Imèl",
      phone: "Telefòn",
      confirm_password: "Konfime modpas la",
      passwords_dont_match: "Modpas yo pa menm.",
      forgot_title: "Bliye modpas ou ?",
      forgot_sub: "Antre imèl ou — n ap voye yon lyen pou reyajiste li.",
      send_reset_link: "Voye lyen an",
      sending: "K ap voye…",
      back_to_login: "Retounen nan koneksyon",
      back_to_landing: "Retounen sou paj dakèy",
      reset_title: "Reyajiste modpas ou",
      reset_sub: "Chwazi yon nouvo modpas pou kont ou.",
      new_password: "Nouvo modpas",
      reset_password: "Reyajiste modpas",
      resetting: "K ap reyajiste…",
      reset_success: "Modpas reyajiste. Ou ka konekte kounye a.",
      email_sent: "Gade nan bwat resepsyon ou pou enstriksyon yo.",
      two_factor_title: "Antre kòd verifikasyon",
      two_factor_sub: "Nou voye yon kòd 6 chif nan {{email}}. L ap ekspire nan {{minutes}} minit.",
      code: "Kòd verifikasyon",
      verify: "Verifye",
      verifying: "K ap verifye…",
      resend_code: "Voye kòd la ankò",
      resend_in: "Voye ankò nan {{seconds}} s",
      trust_device: "Fè aparèy sa a konfyans (pa mande SMS pwochen fwa)",
      device_name: "Non aparèy (opsyonèl)",
      cancel: "Anile",
      pw_rule_length: "Omwen 8 karaktè",
      pw_rule_upper: "Yon lèt majiskil (A-Z)",
      pw_rule_lower: "Yon lèt miniskil (a-z)",
      pw_rule_digit: "Yon chif (0-9)",
      pw_rule_special: "Yon karaktè espesyal (!@#$…)",
    },
    pwreset: {
      title: "Bliye modpas ou ?",
      step1_sub: "Antre non itilizatè, imèl, oswa nimewo telefòn anrejistre ou. N ap voye yon kòd 6 chif pa SMS nan telefòn ou.",
      step1_sub_v2: "Antre imèl anrejistre ou oswa nimewo telefòn mobil anrejistre ou. N ap voye yon kòd 6 chif pa SMS nan telefòn ki anrejistre nan kont ou.",
      identifier_label: "Non itilizatè, Imèl oswa Telefòn (E.164)",
      identifier_label_v2: "Imèl oswa nimewo telefòn mobil",
      identifier_placeholder_v2: "Antre imèl anrejistre ou oswa nimewo telefòn mobil anrejistre ou",
      identifier_examples: "Egzanp : john@example.com  ·  +56961234567",
      identifier_invalid: "Antre yon imèl valab (non@egzanp.com) oswa yon telefòn nan fòma E.164 (pa egzanp +56961234567).",
      send_sms: "Voye kòd verifikasyon",
      step2_title: "Antre kòd SMS la",
      step2_sub_sent: "Yon kòd 6 chif voye nan",
      step2_sub_expiry: "L ap ekspire nan 5 minit.",
      step2_sub_generic: "Si kont sa a egziste, yon kòd 6 chif voye nan telefòn ki anrejistre a. L ap ekspire nan 5 minit.",
      step2_generic_v2: "Si enfòmasyon ou antre yo valab, yon kòd verifikasyon voye. L ap ekspire nan 5 minit.",
      step2_nomatch_hint: "Ou pa resevwa anyen ? Verifye byen non itilizatè, imèl, oswa telefòn ou (fòma E.164 tankou +56961000199). Si kont ou anrejistre san nimewo telefòn, kontakte sipò pou reyajiste modpas ou.",
      code_label: "Kòd 6 chif",
      resend_in: "Voye ankò nan {{s}}s",
      resend_sms: "Voye SMS ankò",
      change_identifier: "Sèvi ak yon lòt kont",
      change_identifier_v2: "Sèvi ak yon lòt imèl oswa telefòn",
      verify: "Verifye kòd",
      invalid_code_generic: "Kòd ou antre a pa valab oswa li ekspire.",
      step3_title: "Kreye yon nouvo modpas",
      step3_sub: "Modpas la dwe genyen omwen 8 karaktè, yon lèt majiskil ak yon miniskil, yon chif ak yon karaktè espesyal.",
      step3_sub_v2: "Chwazi yon modpas ki fò. Tout kondisyon anba yo dwe respekte.",
      new_password: "Nouvo modpas",
      confirm_password: "Konfime nouvo modpas la",
      pw_rule_length: "Omwen 8 karaktè",
      pw_rule_letter: "Omwen yon lèt",
      pw_rule_digit: "Omwen yon chif",
      pw_rule_no_edge_space: "Pa gen espas nan kòmansman oswa nan fen",
      updating: "K ap mete ajou…",
      update_password: "Mete modpas ajou",
      reset_password: "Reyajiste modpas",
      mismatch: "Modpas yo pa menm.",
      resent: "Nouvo SMS voye ({{used}}/{{max}})",
      done_title: "Modpas mete ajou",
      done_title_v2: "Modpas mete ajou avèk siksè",
      done_sub: "Tout sesyon aktif ak aparèy konfyans pou kont sa a revoke. Konekte avèk nouvo modpas ou — yon nouvo kòd SMS ap nesesè pou aparèy sa a.",
      done_sub_v2: "Modpas ou mete ajou avèk siksè.",
      back_to_login: "Tounen sou koneksyon",
      step_identify: "Idantifye",
      step_verify: "Verifye",
      step_new: "Nouvo modpas",
    },
    landing: {
      nav_home: "Akèy",
      nav_about: "Konsènan",
      nav_services: "Sèvis",
      nav_products: "Pwodwi",
      nav_partners: "Patnè",
      nav_contact: "Kontakte",
      cta_login: "Konekte",
      cta_dashboard: "Ale nan Dashboard",
      hero_kicker: "Rapid · Sekirize · Mondyal",
      hero_title: "Konekte mond lan avèk {{brand}}",
      hero_subtitle: "Yon platfòm senp, rapid ak sekirize pou rechaj mobil entènasyonal, peman dijital ak jesyon rezo revandè ou.",
      hero_cta_learn: "Dekouvri sèvis yo",
      hero_trust_secure: "Kripte nivo bank",
      hero_trust_instant: "Règleman an tan reyèl",
      hero_trust_multi: "Rezo milti-wòl",
      promo_text: "",
      about_kicker: "Konsènan nou",
      about_title: "Konsevi pou revandè, chwazi pa ajan.",
      about_p1_prefix: "{{brand}} se yon platfòm mondyal rechaj konsevi pou ",
      about_p1_role1: "master agent",
      about_p1_between: " ak ",
      about_p1_role2: "ajan sou teren",
      about_p1_suffix: ". Nou ba ou zouti operasyonèl — bous, gran-liv, resi ak konfòmite — pou ou konsantre sou sèvi kliyan ou yo.",
      about_p2: "Soti nan operasyon nan yon sèl peyi rive nan rezo milti-rejyon, zouti nou yo grandi avèk ou : komisyon transparan, analiz an tan reyèl, ak odit nivo antrepriz.",
      value_secure_title: "Sekirite pa konsepsyon",
      value_secure_desc: "2FA, aparèy konfyans, odit sou chak aksyon.",
      value_realtime_title: "Tan reyèl",
      value_realtime_desc: "Bous, gran-liv ak resi enstantane.",
      value_hierarchy_title: "Milti-wòl",
      value_hierarchy_desc: "Master Agent · Agent · Collaborator.",
      value_global_title: "Mondyal",
      value_global_desc: "Milti-devi, milti-peyi, bous ankre nan USD.",
      value_whitelabel_title: "White Label",
      value_whitelabel_desc: "Pwòp mak, pèsonalizasyon ak eksperyans pare pou biznis ou.",
      services_kicker: "Sèvis",
      services_title: "Tout sa rezo revandè ou bezwen.",
      services_sub: "Kat sèvis prensipal — yon platfòm entegre, yon bous, yon dashboard.",
      svc_giftcards_title: "Kat kado",
      svc_giftcards_desc: "Kat kado dijital pou mak ak platfòm popilè, livre enstantane.",
      svc_topup_title: "Rechaj ak peman fakti",
      svc_topup_desc: "Rechaj mobil enstantane ak peman sèvis nan santèn operatè atravè mond lan.",
      svc_intl_calls_title: "Apèl entènasyonal",
      svc_intl_calls_desc: "Nou konnen tan yo difisil kounye a, men pri pa dwe janm anpeche w rete an kontak ak fanmi ou.",
      svc_api_title: "Entegrasyon API",
      svc_api_desc: "API REST pou biznis ak revandè ki vle entegre rechaj, retrè lajan ak kat kado natifman.",
      products_kicker: "Pwodwi",
      products_title: "De fason pou jere biznis ou.",
      prod_web_title: "Pòtay Web",
      prod_web_desc: "Dashboard revandè konplè : bous an tan reyèl, rechaj enstantane, komisyon transparan, kliyan verifye, resi ak rapò.",
      prod_web_bullet_0: "Yerachi milti-wòl — Master Agent · Agent · Collaborator",
      prod_web_bullet_1: "Bous USD avèk rechaj enstantane",
      prod_web_bullet_2: "Resi PDF ak rapò nivo odit",
      prod_web_master_label: "Master Agent",
      prod_web_agent_label: "Agent",
      prod_mobile_title: "Aplikasyon mobil",
      prod_mobile_desc: "Voye rechaj, verifye idantite, apwouve retrè ak siveye ajan ou depi kèlkeswa kote w.",
      prod_mobile_bullet_0: "Eksperyans natif pou ajan sou wout",
      prod_mobile_bullet_1: "Notifikasyon pouse pou apwobasyon annatant",
      prod_mobile_bullet_2: "Resi ki disponib san koneksyon",
      partners_kicker: "Sèvis disponib",
      partners_title: "Voye rechaj nan gwo operatè yo.",
      partners_sub: "Anba a se yon echantiyon operatè ki disponib atravè platfòm nou. Kontakte ekip sipò nou pou lis konplè a — santèn rezo nan douzèn peyi.",
      partners_disclaimer: "Tout mak, non komèsyal ak logo ki mansyone se pwopriyete pwopriyetè yo respektif e yo montre sèlman pou idantifye sèvis ki disponib atravè platfòm nou.",
      stats_title: "Nou pale ak nimewo",
      stat_operators: "Operatè",
      stat_countries: "Peyi disponib",
      stat_users: "Itilizatè nan mond",
      stat_support: "Sipò kliyan",
      cta_title: "Ou pare pou kòmanse revann?",
      cta_sub: "Konekte nan kont ou oswa kontakte ekip nou pou vin yon patnè.",
      cta_whatsapp: "Kominike sou WhatsApp",
      cta_email_label: "Voye imèl",
      contact_form: {
        title: "Kontakte My GlobalTopup",
        subtitle: "Voye nou yon mesaj — ekip nou an ap reponn ou pi vit posib.",
        field_name: "Non konplè",
        field_email: "Adrès imèl",
        field_phone: "Telefòn mobil (opsyonèl)",
        field_subject: "Sijè (opsyonèl)",
        field_message: "Mesaj",
        hint_phone: "Fòma entènasyonal, egzanp +56961234567",
        ph_name: "Egz.: Jan Pyè",
        ph_subject: "Ki jan nou ka ede w ?",
        ph_message: "Pale nou yon ti kras sou biznis ou epi ki jan nou ka ede w.",
        err_name: "Antre non konplè ou.",
        err_email: "Antre yon adrès imèl valab.",
        err_phone: "Sèvi ak fòma entènasyonal (egz.: +56961234567).",
        err_message: "Ekri yon ti mesaj (omwen 5 karaktè).",
        err_message_long: "Mesaj la twò long (maksimòm 2000 karaktè).",
        err_send: "Nou pa t kapab livre mesaj ou. Tanpri eseye ankò byento.",
        cancel: "Anile",
        send: "Voye mesaj la",
        sending: "K ap voye…",
        close: "Fèmen",
        done: "Fini",
        success_title: "Mesaj voye avèk siksè",
        success_body: "Mèsi paske w kontakte My GlobalTopup. Ekip nou an ap reponn ou pi vit posib.",
      },
      footer_tagline: "Yon platfòm senp, rapid ak sekirize pou rechaj mondyal ak peman dijital.",
      footer_company: "Konpayi",
      footer_services: "Sèvis",
      footer_products: "Pwodwi",
      footer_legal: "Legal",
      footer_privacy: "Politik konfidansyalite",
      footer_terms: "Kondisyon jeneral",
      footer_rights: "Tout dwa rezève.",
      footer_login: "Konekte",
      footer_forgot: "Bliye modpas",
      footer_follow: "Swiv nou",
      footer_download: "Telechaje aplikasyon an",
      footer_play_get: "Disponib sou",
      legal_back_home: "Retounen nan akèy",
    },
  },
};

export default ht;
